import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './Util/Session/session.service';
import { environment } from '../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SeparationModuleService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  SeparationRuleInsertUpdate(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `SeparationRuleInsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  SeparationRuleLoad(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `SeparationRuleLoad`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpSeparationRequestSave(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `EmpSeparationRequestSave`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  EmpSeparationRequestLoad(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `EmpSeparationRequestLoad`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  ESS_SeparationApprove(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `ESS_SeparationApprove`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  AdminSeparationRequestSave(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `AdminSeparationRequestSave`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }
}